const Icon = () => (
  <>
    <path d="M21.758 1002.232c-29.009-29.009-29.009-76.041 0-105.050l875.414-875.426c29.009-29.009 76.041-29.009 105.050 0s29.009 76.042 0 105.051l-875.413 875.424c-29.009 29.009-76.041 29.009-105.050 0z"></path>
    <path d="M21.778 21.767c29.009-29.009 76.041-29.009 105.050 0l875.414 875.423c29.009 29.009 29.009 76.045 0 105.054s-76.041 29.009-105.050 0l-875.414-875.425c-29.009-29.009-29.009-76.042 0-105.051z"></path>
  </>
)

export default Icon
